import * as yup from 'yup';

export const schema = yup
  .object({
    content: yup.object().required(),
  })
  .transform(value => ({
    content: value.content?.[0],
  }));
